import Cookies from 'js-cookie';

export const ACCESS_TOKEN_MAX_AGE_SECONDS = 60 * 60;

export interface CookieOptions {
  expires?: number | Date;
  maxAge?: number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'strict' | 'lax' | 'none';
}

const toJsCookieOptions = (options?: CookieOptions): Cookies.CookieAttributes => {
  if (!options) return {};
  const { maxAge, ...rest } = options;
  const expires =
    rest.expires ?? (maxAge != null ? maxAge / (60 * 60 * 24) : undefined);
  return { ...rest, expires };
};

export const getCookie = (name: string): string | undefined => Cookies.get(name);

export const setCookie = (
  name: string,
  value: string,
  options?: CookieOptions,
): void => {
  Cookies.set(name, value, toJsCookieOptions(options));
};

export const deleteCookie = (name: string, options?: CookieOptions): void => {
  Cookies.remove(name, toJsCookieOptions(options));
};

export const hasCookie = (name: string): boolean =>
  Cookies.get(name) !== undefined;
